import React from 'react'
import { BaseForm, Checkbox } from '../../../../../../components/Form'
import Loader from '../../../../../../components/Loader'
import { getMessage } from '../../../../../../lib/translator'
import API from '../../../../../../lib/api'

export default class DispatchOrderForm extends BaseForm {
  constructor(props) {
    super(props)
    this.state = {
      values: {
        communication: true,
      },
    }
  }

  onSubmit(formData) {
    this.setState({
      loading: true,
    })
    const referenceNumber = this.props.data.referenceNumber
    const api = new API({
      url: `/order-service/v3/deliveryOrders/${referenceNumber}/dispatch`,
    })
    return api.post(formData, {}).then(() => {
      this.props.updateCompleted()
    })
  }

  render() {
    const { SubmitButton, CancelButton } = this.buttons
    const { Form } = this.components

    return this.state.loading || !this.props.data ? (
      <Loader />
    ) : (
      <Form className="dispatch-order-form">
        <div>
          <Checkbox
            name="notify-customer"
            label={getMessage(
              'deliveryOrder.details.action.notifyCustomer.title'
            )}
            inlineLabel={getMessage(
              'deliveryOrder.details.action.notifyCustomer.text'
            )}
            {...this.generateStateMappers({
              stateKeys: ['communication'],
              loseEmphasisOnFill: true,
            })}
          />
        </div>
        <div className={`form-actions`}>
          <CancelButton>
            {getMessage('deliveryOrder.details.action.cancel')}
          </CancelButton>
          <SubmitButton testid="dispatch-order-submit">
            {getMessage('deliveryOrder.details.action.save')}
          </SubmitButton>
        </div>
      </Form>
    )
  }
}
